import React from 'react';

const CustomOnePage = () => <div>Custom Page 1</div>;

export default CustomOnePage;
